const EmotionNames = ["none", "smile", "cry", "surprised", "angry"];
export {EmotionNames};
